/**
 * BrukerImportDialog - tynn innpakning rundt den generiske ImportDialog for import av brukere.
 * Se backend/shared/import/README.md.
 */
import React from 'react';
import ImportDialog from '../common/import/ImportDialog';
import { lagImportAPI } from '../../services/api/import.api';

interface BrukerImportRad {
  fornavn: string;
  etternavn: string;
  epost: string;
  telefon: string;
  landkode: string | null;
}

interface BrukerImportResultat {
  nyeBrukere: number;
  hoppetOver: number;
}

const api = lagImportAPI<BrukerImportRad, BrukerImportResultat>('/users/import');

const KOLONNER = [
  { felt: 'fornavn', overskrift: 'Fornavn' },
  { felt: 'etternavn', overskrift: 'Etternavn' },
  { felt: 'epost', overskrift: 'E-post' },
  { felt: 'telefon', overskrift: 'Telefon' },
  { felt: 'landkode', overskrift: 'Landkode' },
];

const HJELPETEKST =
  'Last opp .xlsx eller .csv (UTF-8) med kolonnene Fornavn | Etternavn | E-post | Telefon | Landkode, maks 1000 rader. Tom landkode blir +47. Alle får rollen Bruker, og ingen får e-post fra Voluplan. De logger inn med «Glemt passord» eller Google/Facebook. I Google Sheets: Fil → Last ned → Microsoft Excel (.xlsx).';

interface Props {
  open: boolean;
  onClose: () => void;
  onImportert: () => void;
}

const nyeBrukere = (n: number) => `${n} ${n === 1 ? 'ny bruker' : 'nye brukere'}`;
const brukere = (n: number) => `${n} ${n === 1 ? 'bruker' : 'brukere'}`;
const rader = (n: number) => `${n} ${n === 1 ? 'rad' : 'rader'}`;

const BrukerImportDialog: React.FC<Props> = ({ open, onClose, onImportert }) => (
  <ImportDialog<BrukerImportRad, BrukerImportResultat>
    open={open}
    onClose={onClose}
    onImportert={onImportert}
    tittel="Importer brukere"
    hjelpetekst={HJELPETEKST}
    api={api}
    kolonner={KOLONNER}
    maksRader={1000}
    malFilnavn="brukerimport.xlsx"
    oppsummering={(_f, valgte) => {
      const nye = valgte.filter((r) => r.status === 'ny').length;
      const finnes = valgte.filter((r) => r.status === 'finnes').length;
      return `${nyeBrukere(nye)}, ${finnes} finnes allerede. Rader med e-post som allerede er i bruk, hoppes over.`;
    }}
    formaterResultat={(r) =>
      r.hoppetOver > 0
        ? `Importerte ${brukere(r.nyeBrukere)}. ${rader(r.hoppetOver)} ble hoppet over fordi e-posten allerede er i bruk.`
        : `Importerte ${brukere(r.nyeBrukere)}.`
    }
  />
);

export default BrukerImportDialog;
